import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter} from "react-router-dom";
import http from "./sitel/commons/services/http";
import log from "./sitel/commons/services/log";
import auth from "./sitel/demon/services/auth";
import App from './App';

import "./sitel/demon/ui/demon.css";

//INIT THE APP can be from env or hard coded
log.init.setLogHandler(process.env.REACT_APP_LOG_HANDLER);
log.init.setLogLevel(process.env.REACT_APP_LOG_LEVEL);
http.setAppApiBaseUrl(process.env.REACT_APP_API_ENDPOINT);
http.setLogoutCallback(auth.localLogout);
auth.setTokenKeyName(process.env.REACT_APP_AUTH_TOKEN_NAME);
auth.setOauth(process.env.REACT_APP_OAUTH_LOGOUT_URL);
const baseName = "/oh-requests";

//redirect to Central for user login/create account
const user = auth.getCurrentUser();
if(!user || !user.userId){
    window.location.href = `${window.location.origin}/central${baseName}/auth`;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter basename={baseName}>
        <App basename={baseName} />
    </BrowserRouter>
);
